import type { Sku, Product } from './product-types';
export function skuInStock(sku: Pick<Sku,'availability'|'saleStatus'>) {
  return sku.saleStatus === 'available';
}
export function saleCopy(sku: Sku) {
  if (sku.saleStatus === 'available') return '有货';
  if (!sku.saleStatus || sku.saleStatus === 'unknown' || sku.availability === 'unknown') return '库存待确认';
  if (sku.saleStatus === 'off_shelf') return '已下架';
  if (sku.saleStatus === 'no_link') return '暂不可购买';
  return '暂时无货';
}
export function productSaleCopy(product: Pick<Product,'saleStatus'>) {
  if (product.saleStatus === 'available') return '有货';
  if (product.saleStatus === 'not_sold') return '暂无在售商品';
  if (!product.saleStatus || product.saleStatus === 'unknown') return '库存待确认';
  if (product.saleStatus === 'off_shelf') return '已下架';
  if (product.saleStatus === 'no_link') return '暂不可购买';
  return '暂时无货';
}
export function productAction(_product: Product) {
  return '点击查看';
}
export function skuCanOpen(sku: Sku) {
  // Stock is not a navigation permission. Only use validated concrete targets.
  const miniTarget = /^wx[0-9a-fA-F]{16}$/.test(sku.miniAppId || '') && /^\/ec_goods\/detail\?/.test(sku.miniProgramUrl || '');
  let webTarget = false;
  try { webTarget = new URL(sku.purchaseUrl || '').protocol === 'https:'; } catch { /* No web target. */ }
  return webTarget || miniTarget;
}
export function aiErrorCopy(error: unknown) {
  const code = (error as {code?:string})?.code;
  const copy:Record<string,string>={
    request_timeout:'识别等待超时，照片已保留，可以直接重试。',
    network_error:'网络连接失败，照片已保留。请检查网络后重试。',
    catalog_unavailable:'商品目录暂时不可用，照片已保留，请稍后重试。',
    ai_settings_unavailable:'识别服务暂时不可用，请稍后重试。',
    ai_not_configured:'图片识别尚未启用，请改用名称搜索。',
    ai_auth_failed:'识别服务配置异常，请稍后再试。',
    ai_credit_exhausted:'识别服务暂时不可用，请稍后再试。',
    local_rate_limited:'操作有些频繁，请稍后再试。',
    upstream_rate_limited:'识别服务繁忙，请稍后再试。',
    upstream_timeout:'图片分析超时，照片已保留，可以直接重试。',
    upstream_error:'识别服务暂时异常，照片已保留，请稍后重试。',
    overloaded:'识别服务繁忙，照片已保留，请稍后重试。',
    invalid_ai_response:'这次图片分析没有完成，照片已保留，可以重试或换图。',
    invalid_image_format:'图片格式不支持，请改用 JPG、PNG 或 WebP 图片。',
    input_file_too_large:'原图超过 10MB，请换一张较小的图片。',
    image_decode_failed:'图片已损坏或无法读取，请重新选择。',
    image_processing_failed:'浏览器无法处理这张图片，请重试或换一张较小的图片。',
    payload_too_large:'照片处理后仍然过大，请减少照片或换较小的图片。',
    invalid_request:'提交内容不符合要求，请调整后重试。',
  };
  return (code ? copy[code] : undefined) || (error instanceof Error ? error.message : '识别暂时无法完成，照片已保留，请稍后重试。');
}
export function orderedFilterOptions<T extends {value:string;label:string}>(options:T[], selected:string[], query:string) {
  const chosen=new Set(selected);
  return options.filter(o=>chosen.has(o.value)||o.label.toLowerCase().includes(query.toLowerCase()))
    .sort((a,b)=>Number(chosen.has(b.value))-Number(chosen.has(a.value)));
}

export function skuAction(sku: Sku): 'purchase' | 'wishlist' | 'retry' {
  if (skuInStock(sku)) return 'purchase';
  if (!sku.saleStatus || sku.saleStatus === 'unknown') return skuCanOpen(sku) ? 'purchase' : 'retry';
  return 'wishlist';
}
